import { DateRange } from '@components/TimePicker'
import Textfield from '@components/Textfield'
import CloseButton from '@components/CloseButton'
import ListItem from './ListItem'

import './index.scss'

const SearchEventsModal = ({
    events,
    onClose,
    loading,
    initialValue,
    onInputValueChange,
    selectHandler,
    onDateInputChange,
}) => (
    <div className="search-events-modal">
        <div className="search-events-modal__header">
            <Textfield
                autoFocus
                initialValue={initialValue}
                onChange={onInputValueChange}
                label={<T>events.search.modal.input.placeholder</T>}
                isLoading={loading}
                iconLeft="pin-indigo-bookable-act"
            />
            <CloseButton size="xxs" action={onClose} />
            <div className="search-events-modal__header__dateRange row  no-gutters">
                <div className="col-sm-3 pr-2">
                    <T>events.search.modal.date.range</T>
                </div>
                <div className="col-sm-9 search-events-modal__header__datepicker">
                    <DateRange
                        className="w-100 mt-2"
                        onChange={onDateInputChange}
                        startOptions={{
                            label: <T>events.search.modal.date.range.start</T>,
                        }}
                        endOptions={{
                            label: <T>events.search.modal.date.range.end</T>,
                        }}
                        clear
                    />
                </div>
            </div>
        </div>
        <div className="search-events-modal__body">
            <div>
                {events.length > 0 ? (
                    events.map((rate, index) => <ListItem onClick={selectHandler} key={index} {...rate} />)
                ) : (
                    <p className="text-center my-5">
                        {loading ? <T>events.search.modal.loading</T> : <T>events.search.modal.no.results</T>}
                    </p>
                )}
            </div>
        </div>
    </div>
)

SearchEventsModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    initialValue: PropTypes.string,
    onInputValueChange: PropTypes.func.isRequired,
    selectHandler: PropTypes.func.isRequired,
    onDateInputChange: PropTypes.func.isRequired,
}

export default SearchEventsModal
